<template>
    <div>

        <div v-if="new_candidature">
            <div v-if="edit_roles">
                <h4 style="margin-top:7px">{{ __("forms.questionLabels.selectRoleRecruiting") }} </h4>
                <div>
                      <select class="form-control" v-model="role" @change="addRoleApplicant($event)">

                          <option v-for="role in rolesBySet" :value="role.id">
                              {{role.name}}
                          </option>
                      </select>
                </div>
            </div>
            <br>
            <label>{{ __("forms.questionLabels.selectedRoleRecruiting") }}</label>
            <div class="form-group">
                <div style="margin-top:10px;" class="row" v-for="(role,index) in candidatureRoles">
                    <div class="col-2" v-if="edit_roles">
                      <button type="button" class="btn btn--danger" @click="rmRoleApplicant(index)"><i class="fas fa-trash"></i></button>
                    </div>
                    <div class="col-5">
                      <input type="hidden" :value="role.id" :name="'question['+question_id+'][applicant_data]['+key_config+'][]>'" >
                      <label>{{ role.name }}</label>
                    </div>

                </div>
            </div>
        </div>
        <div v-else>

          <div class="form-group">
            <div class="row" v-for="(role,index) in candidature_roles">
              <div class="col-3">

              </div>
              <div class="col-5">
                <label>{{ role.name }}</label>
              </div>

            </div>
          </div>
        </div>


    </div>
</template>

<script>
export default {
    props: {

        key_config: {
            type:String,
            required:true,
        },
        question_id: {
            type:Number,
            required:true,
        },
        edit_roles: {
            type:Boolean,
            required:true,
        },
        role_set: {
            type:Number,
            required:true,
        },
        candidature_roles: {
            type:Array,
            required:true,
        },

        new_candidature :{
            type: Boolean,
            required: true
        },


    },

    data () {
        return {

          rolesBySet : [],
          role : null,
          //
          candidatureRoles : [],
        }
    },

    methods: {

      getRoleBySet(){
        axios.get("/roles-by-role-set?role_set="+this.role_set)
            .then((response) => {

              this.rolesBySet = response.data;
            });
      },

      addRoleApplicant(event){

        this.candidatureRoles.push({
            "id" : event.target.value,
            "name" : event.target.options[event.target.options.selectedIndex].text
        });

      },
      rmRoleApplicant(index){
        console.log(index);
        this.candidatureRoles.splice(index,1);
      }
    },

  mounted () {
    this.getRoleBySet();
    this.candidatureRoles = this.candidature_roles;
  }
}
</script>

<style>

</style>
